module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "group-card"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": _vm.routes,
      "divider": "|"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "page-header mt-5"
  }, [_vm._v("Dashboard")]), _vm._v(" "), _c('div', {
    staticClass: "dashboard-container mt-6"
  }, [_c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "width": "100%",
      "height": "675",
      "src": _vm.lookerStudioUrl,
      "frameborder": "0",
      "allowfullscreen": "",
      "sandbox": "allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-224e49fa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/components/Home.vue
// module id = 1523
// module chunks = 1